import { render } from "./BulkActionBar.vue?vue&type=template&id=4a7e165f&scoped=true"
import script from "./BulkActionBar.vue?vue&type=script&lang=js"
export * from "./BulkActionBar.vue?vue&type=script&lang=js"

import "./BulkActionBar.vue?vue&type=style&index=0&id=4a7e165f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a7e165f"]])

export default __exports__